import styled from 'styled-components';
import media from '../../constants/media';
import { H1 } from '../base/typography';

export const Wrapper = styled.div`
	position: relative;
	margin: 10rem 0 10rem 0;

	> svg {
		position: absolute;
		right: -80rem;
		top: 43rem;
		z-index: -1;
		transform: scaleX(-1) scaleY(-1);
		z-index: -1;
	}

	${media.tablet`
		margin: 20rem 0 10rem 0;
	`};
`;
export const Title = styled(H1)`
	margin-bottom: 6rem;
	text-align: center;
	color: ${({ theme }) => theme.colors.black};
	font-family: ${({ theme }) => theme.fonts.ArimoBold};
	font-size: 6rem;
`;

export const TileTitle = styled.div`
	font-family: ${({ theme }) => theme.fonts.ArimoBold};
	color: ${({ theme }) => theme.colors.primary};
	font-size: 4rem;
	font-weight: 700;
	text-align: center;
	margin: 0 -3rem 0;
	padding: 2rem 0;
	border-bottom: 1px solid ${({ theme }) => theme.colors.grayLight};
	transition: 0.2s;
`;

export const TileWrapper = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	background-color: ${({ theme }) => theme.colors.white};
	border: 1px solid ${({ theme }) => theme.colors.grayLight};
	border-radius: 10px;
	padding: 0 3rem 3rem;
	transition: 0.2s;
	&:hover {
		transition: 0.2s;
		border: 1px solid ${({ theme }) => theme.colors.primary};
		${TileTitle} {
			border-bottom: 1px solid ${({ theme }) => theme.colors.primary};
		}
	}
`;

export const TileChecklist = styled.ul`
	margin: 3.8rem 0;
`;
export const CheckedItem = styled.li`
	display: grid;
	grid-template-columns: calc(20px + 3rem) auto;
	align-items: center;
	margin-bottom: 2.5rem;
	list-style: none;
	> svg {
		width: 20px;
		color: ${({ theme }) => theme.colors.primary};
	}
	> span {
		font-family: ${({ theme }) => theme.fonts.ArimoRegular};
		font-weight: 400;
		font-size: 1.8rem;
	}
`;

export const PriceWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	margin-top: auto;
	padding-bottom: 2rem;
	border-bottom: 1px solid ${({ theme }) => theme.colors.grayLight};
`;
export const PriceString = styled.span`
	font-family: ${({ theme }) => theme.fonts.ArimoRegular};
	font-weight: 700;
	font-size: 2rem;
	color: ${({ theme }) => theme.colors.black};
`;
export const Price = styled.span`
	font-family: ${({ theme }) => theme.fonts.ArimoRegular};
	font-weight: 700;
	font-size: 2rem;
	color: ${({ theme }) => theme.colors.primary};
`;

export const TileLink = styled.a`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 1.5rem;
	margin-top: 2rem;
	background-color: ${({ theme }) => theme.colors.primary};
	font-size: 1.6rem;
	font-weight: 500;
	font-family: ${({ theme }) => theme.fonts.ArimoMedium};
	color: ${({ theme }) => theme.colors.white};
`;

export const DisclaimerText = styled.div`
	text-align: right;
	margin-bottom: 2rem;
`;
